var logger = require('./logger');
function encode(obj) {
    var str = '';
    for (var i in obj) {
        if (obj.hasOwnProperty(i)) {
            if (str.length) str += '&';
            str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
        }
    }
    return str;
}

function handleResponse(response, type) {
    if (!response.ok) {
        response
            .text()
            .then(function (text) {
                logger.error(`[umu-upload] ${type} response not ok`, {
                    url: response.url,
                    status: response.status,
                    statusText: response.statusText,
                    responseText: text,
                });
                throw new Error(
                    `[umu-upload] ${type} response not ok: url=${response.url}, status=${response.status}, statusText=${response.statusText}, responseText=${text}`
                );
            })
            .catch(function (e) {
                logger.error(`[umu-upload] ${type} response error:`, {
                    url: response.url,
                    status: response.status,
                    statusText: response.statusText,
                    error: e && (e.stack || e.toString()),
                });
                throw e;
            });
    } else {
        return response.json();
    }
}

function get(url, data) {
    var searchParams = encode(data);
    url = url + (searchParams && (url.indexOf('?') > -1 ? '&' : '?')) + searchParams;
    return fetch(url, {
        credentials: 'include',
    })
        .then(function (response) {
            return handleResponse(response, 'get');
        })
        .catch(function (e) {
            logger.error('[umu-upload] get error:', url, data, e);
            throw e;
        });
}

function post(url, data, options) {
    var body = encode(data);
    options = Object.assign({}, options, {
        body: body,
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });
    return fetch(url, options)
        .then(function (response) {
            return handleResponse(response, 'post');
        })
        .catch(function (e) {
            logger.error('[umu-upload] post error:', {
                url: url,
                data: data,
                options: options,
                error: e && (e.stack || e.toString()),
            });
            throw e;
        });
}

module.exports = {
    get: get,
    post: post,
};
